import axios from "../helper/axiosIntance";
import { baseUrl } from "../helper/constant";
import Header from "./Header";
import EncryptDecrypt from "./EncryptDecrypt";

export default class ProviderReportServices {
  static upload(params, file) {
    const formdata = new FormData();
    if (params?.reportFile) formdata.append("data1", params.reportFile);
    delete params.reportFile;
    const encryptData = EncryptDecrypt.encrypt(params);
    formdata.append("data", encryptData?.data);
    Header.setHeaders();
    return axios.post(`${baseUrl}/admin/upload-provider-report`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  static list(params) {
    Header.setHeaders();
    return axios.post(
      `${baseUrl}/report/list-provider-analysis-details-report`,
      EncryptDecrypt.encrypt(params)
    );
  }
}
